module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-block module-block-recapitulative"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('billingRecap.title')))]), _vm._v(" "), _c('div', {
    staticClass: "row module-block-offer-choice-name"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.choiceName')))])]), _vm._v(" "), (_vm.choiceName) ? _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-10"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.choiceName)
    }
  }), _vm._v(" "), (_vm.choiceCode) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.choiceCode) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n        ("), _c('span', {
    staticClass: "font-italic"
  }, [_vm._v(_vm._s(_vm.$t('billingRecap.choiceCode')) + ": "), _c('span', [_vm._v(_vm._s(_vm.choiceCode))])]), _vm._v(")\n      ")]) : _vm._e()]) : _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.choiceCode))])])]), _vm._v(" "), (_vm.choiceLongDescription) ? _c('div', {
    staticClass: "row module-block-offer-long-description"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.description')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-10"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.choiceLongDescription)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row module-block-payment-at-order-time module-block-recapitulative-max-width pt-2"
  }, [_c('div', {
    class: ("" + (_vm.choiceFreeDays ? 'col-sm-6 col-md-6 col-lg-8' : 'col-sm-6 col-md-6 col-lg-12'))
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('billingRecap.paymentAtOrderTime')))])]), _vm._v(" "), (_vm.choiceFreeDays) ? _c('div', {
    staticClass: "free-days-today col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
  }, [_c('span', [_vm._v("0.00")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])]) : _vm._e()]), _vm._v(" "), (_vm.choiceFreeDays) ? [_c('div', {
    staticClass: "row module-block-offer-free-days module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "free-days-next-label col-sm-6 col-md-6 col-lg-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.paymentAfterFreeDays', {
    freeDays: _vm.choiceFreeDays
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "free-days-next-price col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.presentFloat(_vm.orderTotal)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])])])] : [_c('div', {
    staticClass: "row module-block-offer-price module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.price')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.presentFloat(_vm.choicePrice)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])])]), _vm._v(" "), (_vm.choiceShippingPrice) ? _c('div', {
    staticClass: "row module-block-offer-delivery module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.shippingPriceLabel ? _vm.shippingPriceLabel : _vm.$t('billingRecap.shippingPrice')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.presentFloat(_vm.choiceShippingPrice)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row module-block-offer-total module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-8"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('billingRecap.orderTotal')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap font-weight-bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.presentFloat(_vm.orderTotal)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currencyIsoCode))])])])], _vm._v(" "), (_vm.paymentMethod) ? _c('div', {
    staticClass: "row module-block-offer-choice-payment-method module-block-recapitulative-max-width"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('billingRecap.paymentMethod')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-4 text-right text-nowrap"
  }, [_vm._v("\n      " + _vm._s(_vm.Utils.capitalizeFirstLetter(_vm.$t('all.' + _vm.paymentMethod))) + "\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b88528ac","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/billing-recap.vue
// module id = 865
// module chunks = 0 1